import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 50%;
  display: flex;
  flex-direction: column;
  grid-gap: 20px;

  text-align: left;

  h3 {
    font-weight: 600;
    font-size: 18px;
    line-height: 150%;
    text-transform: capitalize;
    color: var(--color-link);
    margin: 0;
  }
`;
